// extracted by mini-css-extract-plugin
export default {"services-section":"servicePortfolio_services-section__pfAHy","serial-number":"servicePortfolio_serial-number__1bKiM","service-tab":"servicePortfolio_service-tab__mj+Jz"};